import * as React from 'react';
import { Logger } from '../utils/logger';

export class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    const context = {
      contextData: {
        error: error,
        errorInfo: errorInfo,
        component: this.props.compoennt,
      },
    };
    Logger.instance.error('Bookends Client Error: ', context);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.render) {
        return this.props.render(this.props, this.state);
      } else if (this.props.suppressError) {
        return '';
      } else {
        return '';
      }
    }

    return this.props.children;
  }
}
